import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	HostListener,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges
} from "@angular/core";

import {LogCat, LogManager} from "../../../../log";
import {ACTION_SUFFIX} from "../../../../translate";
import {IButton} from "../../button";
import {MarkOperator} from "../../../services/mark.service";

export interface ISelectableItem {
	description:string;
	selected:boolean;
}
@Component({
	selector:'cp-list-selection-list-item',
	templateUrl: './list.item.template.html',
	styleUrls: ['./list.item.style.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectionListItemComponent implements OnChanges, OnInit, OnDestroy {

	@Input() item: ISelectableItem;
	@Input() searchTerms: string[] = [];
	@Input() alwaysShowRemove: boolean;

	@Output() public addItem: EventEmitter<ISelectableItem> = new EventEmitter();
	@Output() public removeItem: EventEmitter<ISelectableItem> = new EventEmitter();

	public dictionary: any = {};

	public markOperator = MarkOperator;

	public addItemButton: IButton = {
		iconClass: "cp-icon-procedure_add",
		tooltipToTranslate: {
			template: "AddStudyGroup" + ACTION_SUFFIX
		},
		isDisabled: false,
		isSelected: false
	};

	public removeItemButton: IButton = {
		iconClass: "cp-icon-procedure_delete",
		tooltipToTranslate: {
			template: "RemoveStudyGroup" + ACTION_SUFFIX
		},
		isDisabled: false,
		isSelected: false
	};

	@HostBinding('class.selected') isSelected: boolean;

	/*
	* Double Click Handler
	* Add/Remove study to/from study group handler
	* */
	@HostListener('dblclick') dblClickHandler() {
		if (this.item.selected) {
			this.removeItem.emit(this.item);
		} else {
			this.addItem.emit(this.item);
		}
	}

	constructor() {
	}

	public ngOnChanges(changes: SimpleChanges) {
		if (changes.selected) {
			this.isSelected = this.item.selected ? this.item.selected : false;
		}
	}

	public ngOnInit() {
	}

	public ngOnDestroy() {
	}

	/* ***************************************************************************
	* Public Methods
	* ************************************************************************** */

	/*
	* Add study to study group handler
	* */
	public addItemHandler(item: ISelectableItem) {
		this.addItem.emit(item);
	}

	/*
	* Remove study from study group handler
	* */
	public removeItemHandler(study: ISelectableItem) {
		this.removeItem.emit(study);
	}
}
